import { render, staticRenderFns } from "./DialogLeaveTeam.vue?vue&type=template&id=7010ae99&scoped=true"
import script from "./DialogLeaveTeam.vue?vue&type=script&lang=js"
export * from "./DialogLeaveTeam.vue?vue&type=script&lang=js"
import style0 from "./DialogLeaveTeam.vue?vue&type=style&index=0&id=7010ae99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010ae99",
  null
  
)

export default component.exports